import React, { useContext, useState } from "react";
import { LoanFormContext } from "./LoanForm";
import FormStep from "../../FormStep";

const WorkingWithAgent: React.FunctionComponent<{
  onSubmit?: (value: string) => void;
}> = () => {
  return (
    <div>
      <FormStep header={<h1 className="heading-main">Thank you!</h1>}>
        <p>We have received your submission 🙌</p>
      </FormStep>
    </div>
  );
};

export default WorkingWithAgent;
